import { globals } from '@yola/ws-sdk';
import { mutatePaletteElement } from './prepare-palette-element';
import constants from '../constants';

const { GLOBAL_HEADER_CODE } = constants;

const saveGlobalPalette = ({ compiledPalette }) => {
  globals.operations.changeGlobalContent(
    GLOBAL_HEADER_CODE,
    (global) =>
      mutatePaletteElement({
        parentNode: global,
        compiledPalette,
      }),
    false
  );
};

export default saveGlobalPalette;
